import BaseAsyncSelect from 'components/Filters/BaseAsyncSelect'
import { API_SUPER_CATEGORIES } from 'constants/api-v2'
import { useI18n } from 'context/I18nProvider'
import { getId } from 'services/apiPlatform'

export default function SuperCategories({ ...props }) {
  const { i18name } = useI18n()

  return (
    <BaseAsyncSelect
      name="superCategory"
      label="label.super-category"
      url={API_SUPER_CATEGORIES}
      mapper={(opt: any) => ({ ...opt, label: i18name(opt), value: getId(opt) })}
      apiPlatform
      {...props}
    />
  )
}
